import {
  GetOutOfStockProductsInListQuery,
  GetOutOfStockProductsInListQueryVariables
} from '@data/__generated__/types.main'
import {getOutOfStockProductsInListQuery} from '@data/queries/stock/getOutOfStockProductsInList.main'
import isServerSide from '@helpers/misc/isServerSide'
import {useApolloQuery} from 'apollo-hooks'
import uniq from 'lodash/uniq'

export default function useSetOutOfStockProducts({websiteId, categories, storeId, deliverAt}): {
  outOfStockIds: Map<string, boolean>
} {
  const categoriesIds = []

  const cats = categories ? categories.items : []
  for (const category of cats) {
    categoriesIds.push(category._id)
  }

  const {outOfStockIds} = useApolloQuery<
    GetOutOfStockProductsInListQuery,
    GetOutOfStockProductsInListQueryVariables
  >({
    query: getOutOfStockProductsInListQuery,
    variables: {websiteId, categoriesIds: uniq(categoriesIds), storeId, deliverAt},
    partial: true,
    omit: categoriesIds.length === 0 || !storeId || isServerSide()
  })

  if (!outOfStockIds || !outOfStockIds.length) return {outOfStockIds: new Map()}

  return {outOfStockIds: new Map(outOfStockIds.map(id => [id, true]))}
}
